<template>
  <div>
    <!-- 弹窗-添加/修改 -->
    <simple-modal 
      ref    ="modal"
      :title ="title"
      :right ="true"
      :middle="true"
      @submit="submit"
    >
      <template slot="body">
        <!--  -->
        <div>
          <common-form-item 
            :labelweight="165"
            v-for="item in formItem" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
          </common-form-item >
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  props:["sel_organi"],
  name: "modal-area",
  // props:["organi"],
  data() {
    return{
      showEmail: false,
      title:"",
      type :"add",
      formData: new FormClass({ // 弹窗-表单数据
        home_id: this.sel_organi,
        name : {
          init: "",
          check: "smallstr",
        },
      }),
      depts: [],
    }
  },
  mounted(){ },
  computed: {
    formItem(){
      return[
        {
          label  : this.$I18n("equi_area_1"),
          keys     : "name",
          type     : "input",
          check    : true,
          placeholder: this.$I18n("equi_area_2"),
        },
      ]
    },
  },
  methods:{
    /*
      type : add | edit | del
      data : 表单基础数据
    */
    open(type, data){
      this.type = type;
      this.depts = this.UserInfo.depts;
      if(type === "add"){
        this.$refs.modal.open();
        this.formData.Reset();
        this.title = this.$I18n("add_reg")

      } else if(type === "edit"){
        this.$refs.modal.open();
        this.formData.Update(data);
        this.title = this.$I18n("set_reg")
      
      } else if(type === "del"){
        this.formData.Update(data);
        this.$confirm(this.$I18n("conf_del"), this.$I18n("del_reg"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.submit();
        }).catch(() => { })
      }
    },
    submit(){
      if(this.type === "add"){
        this.add();
      } else if(this.type === "edit"){
        this.edit();
      } else if(this.type === "del"){
        this.del();
      }
    },
    // 调用父组件传递的close方法 制造提交成功后执行
    close(){
      this.$refs.modal.close();
      if(this.$listeners["close"]){
       this.$emit('close');
      }
    },
    add(){
      if (this.formData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.a_DevZone(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    edit(){
      if (this.formData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.s_DevZone(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))

    },
    del(){
      this.$api.d_DevZone(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
  },
}
</script>

<style scoped></style>